import { useLanguage } from "../localization/LanguageContext";

function NotFound(){
    const { translation } = useLanguage();

    return (
        <div className="d-flex flex-column flex-grow-1 justify-content-center align-items-center text-center text-nowrap">
            <div className="container"> 
                <h1>
                    404
                </h1>
                <h2>
                    {translation("page_not_found")}
                </h2>        
            </div>
        </div>
    )
    
}

export default NotFound;